export default {
  // FHRS
  FHRS_0: 'fhrs_0_en-gb',
  FHRS_1: 'fhrs_1_en-gb',
  FHRS_2: 'fhrs_2_en-gb',
  FHRS_3: 'fhrs_3_en-gb',
  FHRS_4: 'fhrs_4_en-gb',
  FHRS_5: 'fhrs_5_en-gb',
  FHRS_AWAITING_INSPECTION: 'fhrs_awaitinginspection_en-gb',
  FHRS_EXEMPT: 'fhrs_exempt_en-gb',
  // FHIS (Scotland)
  FHIS_PASS: 'fhis_pass_en-gb',
  FHIS_IMPROVEMENT_REQUIRED: 'fhis_improvement_required_en-gb',
  FHIS_AWAITING_INSPECTION: 'fhis_awaiting_inspection_en-gb',
};
